import React from 'react';

const EditorialAbout = () => {
  return (
    <section className="section-padding bg-gray-100 py-16" id="about">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Big Logo */}
          <div className="flex justify-center lg:justify-start">
            <img 
              src="https://customer-assets.emergentagent.com/job_gamers-unite/artifacts/6of96a1d_bgn%20logo.png" 
              alt="BGN Logo" 
              className="w-64 h-64 object-contain opacity-90"
            />
          </div>
          
          {/* Content */}
          <div className="space-y-8">
            <h2 className="heading-large text-black lowercase">about BGN</h2>
            
            <div className="space-y-6">
              <p className="body-large text-gray-600 leading-relaxed">
                Welcome to the Black Gamers Network — a space built to amplify Black voices 
                in gaming and game development.
              </p>
              
              <p className="body-medium text-gray-600 leading-relaxed">
                We believe that diverse voices make gaming better for everyone. Our platform 
                connects passionate individuals, shares incredible stories, and celebrates the 
                contributions of Black creators in gaming culture.
              </p>
              
              <p className="body-medium text-gray-600 leading-relaxed">
                Through streaming partnerships, community events, and educational resources, 
                we're building the future of inclusive gaming.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialAbout;